import React from 'react';
import { Box, Typography } from '@mui/material';

const FaceGuideOverlay = ({ guidance, countdown, bounds, stepPrompt }) => {
  const boxStyles = bounds
    ? {
        left: `${bounds.minX * 100}%`,
        top: `${bounds.minY * 100}%`,
        width: `${bounds.width * 100}%`,
        height: `${bounds.height * 100}%`,
        borderColor: countdown > 0 ? '#22c55e' : '#f59e0b',
      }
    : {
        left: '20%',
        top: '12%',
        width: '60%',
        height: '76%',
        borderColor: 'rgba(255,255,255,0.7)',
      };

  const countdownPosition = bounds
    ? {
        left: `${bounds.centerX * 100}%`,
        top: `${bounds.centerY * 100}%`,
      }
    : {
        left: '50%',
        top: '50%',
      };

  return (
    <>
      <Box
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          inset: 0,
          borderRadius: 3,
          border: '2px dashed rgba(255,255,255,0.35)',
        }}
      />

      <Box
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          border: '3px solid',
          borderRadius: 2,
          transition: 'all 150ms linear',
          ...boxStyles,
        }}
      />

      <Box
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          left: 12,
          right: 12,
          bottom: 12,
          borderRadius: 2,
          px: 1.5,
          py: 1,
          bgcolor: 'rgba(15, 23, 42, 0.7)',
          color: '#fff',
          backdropFilter: 'blur(3px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        <Box>
          <Typography variant="caption" sx={{ opacity: 0.9 }}>
            Target: {stepPrompt}
          </Typography>
          <Typography variant="body2" fontWeight={700}>
            {guidance}
          </Typography>
        </Box>
      </Box>

      {countdown > 0 && (
        <Box
          sx={{
            pointerEvents: 'none',
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
            width: { xs: 56, sm: 64 },
            height: { xs: 56, sm: 64 },
            borderRadius: '50%',
            bgcolor: 'rgba(14, 116, 144, 0.92)',
            border: '2px solid rgba(255,255,255,0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            zIndex: 6,
            ...countdownPosition,
          }}
        >
          <Typography variant="h4" fontWeight={700} sx={{ lineHeight: 1 }}>
            {countdown}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default FaceGuideOverlay;
